import styled, { css } from "styled-components";

import {
  ArrowLeft,
  Home,
  Search,
  Notifications,
  Email,
} from "../../styles/icons";

export const Container = styled.div`
  display: flex;
  flex-direction: column; //pq aq estiliza o header, o feed e o bottomMenu

  width: min(
    601px,
    100%
  ); //ele terá no máximo 601px de largura máxima, se for menos de 601 será 100% da tela!

  @media (min-width: 500px) {
    // a partir de 500px, vai criar o menu esquerdo pro mobile
    border-left: 1px solid var(--outline);
    border-right: 1px solid var(--outline);
  }
`;

export const Header = styled.div`
  z-index: 2;
  position: sticky; //pra ficar preso na parte de cima da tela
  top: 0;

  background: var(--primary);

  display: flex;
  align-items: center;

  text-align: left;

  padding: 8px 0 8px 13px;

  border-bottom: 1px solid var(--outline);

  > button {
    padding: 8px;
    border-radius: 50%;
    outline: 0;

    cursor: pointer;

    &:hover {
      background: var(--twitter-dark-hover);
    }
  }
`;

export const BackIcon = styled(ArrowLeft)`
  width: 24px;
  height: 24px;

  fill: var(--twitter);
`;
export const ProfileInfo = styled.div`
  margin-left: 17px;

  display: flex;
  flex-direction: column;

  > strong {
    font-size: 19px;
  }

  > span {
    font-size: 15px;
    color: var(--gray);
  }
`;

export const BottomMenu = styled.div`
  //barra fixada em baixo
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  background: var(--primary);

  border-top: 1px solid var(--outline);
  padding: 8px min(46px, max(10vw, 10px)); //pra adptar ao tamanho da tela

  @media(min-width: 500px) { //a partir de 500px cai aq
    display: none;
  }
`;

const iconCSS = css`
  width: 31px;
  height: 31px;

  cursor: pointer;

  fill: var(--gray);

  &:hover,
  &.active {
    fill: var(--twitter);
  }
`;

export const HomeIcon = styled(Home)`
  ${iconCSS}
`;
export const SearchIcon = styled(Search)`
  ${iconCSS}
`;
export const BellIcon = styled(Notifications)`
  ${iconCSS}
`;
export const EmailIcon = styled(Email)`
  ${iconCSS}
`;
